<template>
  <div class="container">
    <div class="row vertical-center pushup">
      <div class="row">
        <div class="col-12">
          <h1>{{ $t("register.caption") }}</h1>
        </div>
        <div class="col-12 form-group pushup">
          <label for="firstname">{{ $t("register.firstname") }}:</label>
          <transition name="err">
            <span
              v-if="validationState === 'ERROR' && !$v.firstname.required"
              class="error pushleft"
              >{{ $t("register.error.firstname") }}</span
            >
          </transition>
          <input
            id="firstname"
            type="text"
            class="form-control"
            v-model="firstname"
            ref="firstname"
            @keydown="validationState = ''"
          />
        </div>
        <div class="col-12 form-group">
          <label for="lastname">{{ $t("register.lastname") }}:</label>
          <transition name="err">
            <span
              v-if="validationState === 'ERROR' && !$v.lastname.required"
              class="error pushleft"
              >{{ $t("register.error.lastname") }}</span
            >
          </transition>
          <input
            id="lastname"
            type="text"
            class="form-control"
            v-model="lastname"
            ref="lastname"
            @keydown="validationState = ''"
          />
        </div>
        <!--<div class="col-12 form-group">
          <label for="mobile">{{ $t("register.mobile") }}:</label>
          <input
            id="mobile"
            type="tel"
            class="form-control"
            v-model="mobile"
            ref="mobile"
            @keydown="validationState=''"exit
          />
        </div>-->
        <div class="col-12 form-group">
          <label for="email">{{ $t("register.email") }}:</label>
          <transition name="err">
            <span
              v-if="validationState === 'ERROR' && !$v.email.required"
              class="error pushleft"
              >{{ $t("register.error.email_required") }}</span
            >
          </transition>
          <transition name="err">
            <span
              v-if="validationState === 'ERROR' && !$v.email.email"
              class="error pushleft"
              >{{ $t("register.error.email_invalid") }}</span
            >
          </transition>
          <input
            id="email"
            type="email"
            class="form-control"
            v-model="email"
            ref="email"
            @keydown="validationState = ''"
          />
        </div>
        <div class="col-12 form-group reduce">
          <label>{{ $t("register.dob") }}:</label>
        </div>
        <div class="col-4">
          <select class="form-control" v-model="dobDay" ref="dobDay">
            <option :value="null">{{ $t("register.day") }}</option>
            <option v-for="day in days" v-bind:key="day.value">
              {{ day.text }}
            </option>
          </select>
          <transition name="err">
            <span
              v-if="validationState === 'ERROR' && !$v.dobDay.required"
              class="error"
              >{{ $t("register.error.dobDay") }}</span
            >
          </transition>
        </div>
        <div class="col-4">
          <select class="form-control" v-model="dobMonth" ref="dobMonth">
            <option :value="null">{{ $t("register.month") }}</option>
            <option v-for="month in months" v-bind:key="month.value">
              {{ month.text }}
            </option>
          </select>
          <transition name="err">
            <span
              v-if="validationState === 'ERROR' && !$v.dobMonth.required"
              class="error"
              >{{ $t("register.error.dobMonth") }}</span
            >
          </transition>
        </div>
        <div class="col-4">
          <select class="form-control" v-model="dobYear" ref="dobYear">
            <option :value="null">{{ $t("register.year") }}</option>
            <option v-for="year in years" v-bind:key="year.value">
              {{ year.text }}
            </option>
          </select>
          <transition name="err">
            <span
              v-if="validationState === 'ERROR' && !$v.dobYear.required"
              class="error"
              >{{ $t("register.error.dobYear") }}</span
            >
          </transition>
        </div>
        <div class="col-12 form-group pushup">
          <label for="postcode">{{ $t("register.postcode") }}:</label>
          <transition name="err">
            <span
              v-if="validationState === 'ERROR' && !$v.postcode.required"
              class="error pushleft"
              >{{ $t("register.error.postcode") }}</span
            >
            <span
              v-if="validationState === 'ERROR' && !$v.postcode.validPostcode"
              class="error pushleft"
              >{{ $t("register.error.invalidpostcode") }}</span
            >
          </transition>
          <input
            id="postcode"
            type="text"
            class="form-control"
            v-model="postcode"
            ref="postcode"
            maxlength="4"
            @keydown="validationState = ''"
          />
        </div>
        <div class="col-12 form-group reduce">
          <label>{{ $t("register.sex") }}:</label>
          <transition name="err">
            <span
              v-if="validationState === 'ERROR' && !$v.sex.required"
              class="error pushleft"
              >{{ $t("register.error.sex") }}</span
            >
          </transition>
        </div>
        <div class="col-6 center radiocontainer">
          <input
            type="radio"
            value="f"
            v-model="sex"
            name="sex"
            class="radio"
            ref="sex"
          />
          <img
            src="../assets/women.png"
            class="circle"
            @click="sex = 'f'"
            alt="female"
          />
          <p style="padding-left: 12px">{{ $t("register.female") }}</p>
        </div>
        <div class="col-6 center radiocontainer">
          <input
            type="radio"
            value="m"
            v-model="sex"
            name="sex"
            class="radio"
          />
          <img
            src="../assets/man.png"
            class="circle"
            @click="sex = 'm'"
            alt="male"
          />
          <p style="padding-left: 12px">{{ $t("register.male") }}</p>
        </div>
        <div class="col-12 pushup">
          <p>{{ $t("register.note") }}</p>

          <p v-html="$t('register.privacy-link-only')"></p>
          <!--<div class="form-check">
            <input
              id="privacy"
              type="checkbox"
              class="form-check-input"
              v-model="privacy"
              ref="privacy"
            />
            <label for="privacy" class="form-check-label" v-html="$t('register.privacy')"></label>
          </div>
          <transition name="err">
            <span
              v-if="validationState==='ERROR' && !$v.privacy.required"
              class="error"
            >{{ $t("register.error.privacy") }}</span>
          </transition>-->
        </div>
        <div class="col-10 pushup">
          <transition name="err">
            <span
              v-if="validationState === 'ALL' && !$v.privacy.required"
              class="error"
              >{{ $t("register.error.all") }}</span
            >
          </transition>
        </div>
        <div class="col-2 right pushup2">
          <button id="button" class="btn btn-primary" @click="next"></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, email, minValue } from "vuelidate/lib/validators"
import JQuery from "jquery"
import participant from "../modules/Participant"
import simulation from "../modules/Simulation"
import PSYAPI from "../modules/API"

let $ = JQuery

const validPostcode = async (value) => {
  let status = 0
  try {
    status = await PSYAPI.postcode.validate(value)
  } catch (e) {
    alert(e)
  }
  return status === 200
}

export default {
  name: "Register",
  data() {
    return {
      firstname: null,
      lastname: null,
      mobile: null,
      email: null,
      dobDay: null,
      dobMonth: null,
      dobYear: null,
      postcode: null,
      sex: null,
      privacy: 1,
      days: this.genDateNums("days"),
      months: this.genDateNums("months"),
      years: this.genDateNums("years"),
      validationState: "",
    }
  },
  validations: {
    firstname: {
      required,
    },
    lastname: {
      required,
    },
    email: {
      required,
      email,
    },
    dobDay: {
      required,
    },
    dobMonth: {
      required,
    },
    dobYear: {
      required,
    },
    postcode: {
      required,
      validPostcode,
    },
    sex: {
      required,
    },
    privacy: {
      required: minValue(1),
    },
  },
  methods: {
    next() {
      this.$v.$invalid
      setTimeout(() => {
        if (this.$v.$invalid) {
          const self = this
          const invalidFields = Object.keys(self.$v.$params).filter(
            (fieldName) => self.$v[fieldName].$invalid
          )

          if (invalidFields) {
            this.$refs[invalidFields[0]].focus()
            if (invalidFields.length > 5) {
              this.validationState = "ALL"
            } else {
              this.validationState = "ERROR"
            }
          }
          setTimeout(() => {
            this.validationState = ""
          }, 30000)
        } else {
          participant.firstname = this.firstname
          participant.lastname = this.lastname
          participant.phone = this.mobile
          participant.email = this.email
          participant.age = new Date().getFullYear() - parseInt(this.dobYear)
          participant.dob = new Date(
            this.dobYear,
            this.dobMonth - 1,
            this.dobDay,
            1
          )
          participant.postcode = {
            id: this.postcode,
            country: { id: "CH", name: "Switzerland" },
          }
          participant.sex = this.sex
          participant.language = {
            id: this.$i18n.locale,
          }

          if (simulation.mode === "staging") {
            let e = simulation.getE(),
              s = simulation.getS(),
              n = simulation.getN(),
              t = simulation.getT(),
              f = simulation.getF(),
              j = simulation.getJ()
            participant.result = simulation.getResult(e, s, n, t, f, j)
            participant.e = e
            participant.s = s
            participant.n = n
            participant.t = t
            participant.f = f
            participant.j = j
            this.$router.push("/orientation")
          } else {
            this.$router.push("/orientation")
          }
        }
      }, 350)
    },
    genDateNums(what) {
      let days = [],
        months = [],
        years = [],
        currentYear = new Date().getFullYear(),
        start = currentYear - 10,
        stop = currentYear - 101

      for (let i = 1; i < 32; i++) {
        days.push({ value: i, text: i })
      }
      for (let i = 1; i < 13; i++) {
        months.push({ value: i, text: i })
      }
      for (let i = start; i > stop; i--) {
        years.push({ value: i, text: i })
      }
      switch (what) {
        case "days":
          return days
        case "months":
          return months
        case "years":
          return years
        default:
          return []
      }
    },
  },
  mounted() {
    this.$refs.firstname.focus()
    $('[data-toggle="popover"]').popover()
    if (simulation.mode === "staging") {
      this.firstname = "Hans"
      this.lastname = "Wurst"
      this.mobile = "0041794644110"
      this.email = "hans.wurst@psyfiers.ch"
      this.dobDay = 12
      this.dobMonth = 3
      this.dobYear = 1966
      this.postcode = 1000
      this.sex = "m"
      this.privacy = 1
    }
  },
  created() {
    if (participant.tan === null) {
      this.$router.push("/tan")
    }
  },
}
</script>

<style scoped>
h1 {
  background-color: #e5efef;
  padding: 10px;
  text-align: center;
}

.container {
  max-width: 600px !important;
}

.radiocontainer input {
  opacity: 0;
}

.radiocontainer input:checked ~ .circle {
  border: 4px solid darkslategray;
}

.reduce {
  margin-bottom: 0px;
}

.pushup {
  margin-top: 16px;
}
.pushup2 {
  margin-top: -16px;
}

.circle {
  height: 80px;
  width: 80px;
  margin: 10px;
  border: 1px solid #cccccc;
  border-radius: 50%;
  background-color: snow;
  padding: 5px;
}

.circle:hover {
  -webkit-box-shadow: 0px 5px 40px -10px rgba(0, 0, 0, 0.57);
  box-shadow: 5px 40px -10px rgba(0, 0, 0, 0.57);
  transition: all 0.4s ease 0s;
  transform: translate(-1px, -1px);
}

.circle:active {
  -webkit-box-shadow: 0px 2px 20px -10px rgba(0, 0, 0, 0.57);
  box-shadow: 2px 20px -10px rgba(0, 0, 0, 0.57);
  transition: all 0.4s ease 0s;
  transform: translate(1px, 1px);
}
.err-enter,
.err-leave-to {
  visibility: hidden;
  opacity: 0;
}
.err-enter-active,
.err-leave-active {
  transition: all, 0.5s;
}
.btn {
  border-radius: 50% !important;
  height: 100px !important;
  width: 100px !important;
  font-size: 0px !important;
}

.btn-primary {
  border-color: white !important;
  background-color: white !important;
  max-width: 100px;
  max-height: 100px;
  background-image: url("../assets/web_button.png");
  background-repeat: no-repeat;
  background-size: cover;
}

@media screen and (max-width: 770px) {
  .container {
    padding: 30px !important;
  }
  #button {
    margin-left: -35px;
  }
}
@media screen and (max-width: 770px) and (orientation: landscape) {
  .btn-primary {
    border-color: white !important;
    background-color: white !important;
    max-width: 65px;
    max-height: 65px;
    background-image: url("../assets/web_button.png");
    background-repeat: no-repeat;
    background-size: cover;
  }

  .btn {
    height: 65px !important;
    width: 65px !important;
    font-size: 0px !important;
  }
}
@media screen and (max-width: 770px) and (orientation: portrait) {
  .btn-primary {
    border-color: white !important;
    background-color: white !important;
    max-width: 65px;
    max-height: 65px;
    background-image: url("../assets/web_button.png");
    background-repeat: no-repeat;
    background-size: cover;
  }

  .btn {
    height: 65px !important;
    width: 65px !important;
    font-size: 0px !important;
  }
}
</style>